// extracted by mini-css-extract-plugin
export default {"userBox":"cart_userBox__60jJB"};